<template>
    <div>
      
        <h2 class="ix-page-title-secondary mt-4">Contenu</h2>
        <div class="row">
            <div class="col-sm-12 col-md-6" v-if="model == 'quote'">
                 <div class="form-group row">
                    <label class="col-sm-4 col-form-label">TVA globale à appliquer</label>
                    <div class="input-group mb-3 col-sm-8">
                        <input type="number" class="form-control" v-model="globalTva" id="global_tva" name="global_tva" step="0.01" placeholder="TVA globale"/>
                        <div class="input-group-append">
                            <span class="input-group-text" id="basic-addon2">%</span>
                        </div>
                    </div>
                </div>
            </div>
           
            <div class="col-sm-12">
                <!-- Le bouton d'enregistrement est grisé tant que ce bandeau est là. -->
                <div class="alert alert-danger" v-if="blockedLines.length > 0">
                    <i class="far fa-exclamation-triangle"></i>
                    <strong>
                        {{ blockedLines.length > 1
                            ? blockedLines.length + ' lignes ne peuvent pas être enregistrées'
                            : 'Une ligne ne peut pas être enregistrée' }}
                    </strong>
                    : corrigez la quantité ou le prix, ou forcez le seuil avec un motif.
                    <div class="mt-1" v-for="line in blockedLines" :key="'blocked-' + line.uniq">
                        {{ line.designation }}
                    </div>
                </div>

                <div class="ix-table-box mb-3">
                    <!-- Un tbody par groupe : une ligne et ses éco-participations se déplacent ensemble. -->
                    <draggable :value="groups" tag="table" class="ix-table ix-table-grouped" handle=".handle-line" draggable=".ix-line-group" @end="moveGroup">
                        <thead slot="header">
                        <tr>
                            <th style="width: 30px;"></th>
                            <th style="width: 30px;">
                                <span data-toggle="tooltip" data-placement="top" title="Définir comme titre"><i class="far fa-text"></i></span>
                            </th>
                            <th style="width: 150px;">Référence</th>
                            <th>Désignation</th>
                            <th style="width: 120px;">Qté</th>
                            <template v-if="showsAvailability">
                                <th class="text-right" style="width: 80px;">Stock</th>
                                <th style="width: 200px;">Disponibilité</th>
                            </template>
                            <th class="text-right" :style="{width: showsAvailability ? '140px' : '180px'}">P.U. HT</th>
                            <th class="text-center" style="width: 120px;">Remise</th>
                            <th class="text-right" :style="{width: showsAvailability ? '140px' : '180px'}">Total H.T.</th>
                            <th class="text-center" style="width: 120px;" v-if="isAutoliquidation != 1">Tva</th>
                            <th style="width: 120px;"></th>
                        </tr>
                        </thead>
                        <tbody v-for="group in groups" :key="group.key" class="ix-line-group">
                            <template v-for="item in group.items">
                            <tr is="line-form"
                                v-bind:key="item.line.uniq"
                                :line="item.line"
                                :index="item.index"
                                :discount="discount"
                                :isAutoliquidation="isAutoliquidation"
                                :suggestionsRoute="suggestionsRoute"
                                :model="model"
                                :id="id"
                                :tva="globalTva"
                                :editable="editable"
                                :companyId="companyId"
                                :recomputeToken="recomputeToken"
                                :articleQuantities="articleQuantities"
                                :canCreateArticle="canCreate"
                                :insight="insights[item.line.article_id] || null"
                                :shows-availability="showsAvailability"
                                :availability="availabilities[item.line.uniq] || null"
                                :can-hide="hideableLineUniqs[item.line.uniq] === true"
                                :shows-hidden-flag="hiddenLinesEnabled === false && item.line.is_hidden_from_client == 1"
                                :is-protected-article="protectedArticleLineUniqs[item.line.uniq] === true"
                                v-on:open-article-modal="openArticleModal($event)"
                                v-on:line-editing-started="checkIfNewRowNeeded($event)"
                                v-on:line-deleted="deleteRow($event)"
                                v-on:line-under-total-edited="computeUnderTotalLine($event)"
                                v-on:add-eco-line="addEcoLine($event)"
                                v-on:remove-eco-lines-for-article="removeEcoLinesForArticle($event)"
                                v-on:update-eco-lines-quantity="updateEcoLinesQuantity($event)"
                                v-on:kit-toggled="rememberKitOpen($event)"
                            ></tr>
                            <tr is="kit-detail-row"
                                v-if="item.line.kit && item.line.kit_open"
                                v-bind:key="item.line.uniq + '-kit'"
                                :kit="item.line.kit"
                                :quantity="item.line.quantity"
                                :demand="demand"
                                :with-lead-time="model == 'quote'"
                                :colspan="columnCount"
                            ></tr>
                            </template>
                        </tbody>
                        <tbody slot="footer" v-if="loading">
                            <tr>
                                <td :colspan="columnCount" class="text-center">
                                    <i class="far fa-circle-notch fa-spin"></i>
                                </td>
                            </tr>
                        </tbody>
                    </draggable>
                </div>

                <button type="button" class="ix-btn link" :disabled="editable ? false : true" @click="addRow(null)"><i class="far fa-plus"></i> Nouvelle ligne</button>
                <div>

                <button type="button" class="ix-btn link" @click="addUnderTotalRow(null)" :disabled="!can_add_line_under_total || (editable ? false : true)"><i class="far fa-plus"></i> Nouveau sous-total</button>
                </div>
                <div v-if="showsShippingButton">
                    <span class="d-inline-block" :title="shippingButtonBlocker">
                        <button type="button" class="ix-btn link" :disabled="!!shippingButtonBlocker" @click="addShippingLine(false)"><i class="far fa-plus"></i> Ligne de frais de port</button>
                    </span>
                </div>
            </div>
        </div>

        <div class="row mb-4 mt-2" v-if="!loading">
            <!-- Toujours posté : le choix reste enregistré même sans article composé dans la grille. -->
            <input type="hidden" name="show_kit_details" :value="showKitDetails ? 1 : 0">
            <input type="hidden" name="show_availability" :value="showAvailability ? 1 : 0" v-if="showsAvailability">
            <div class="col-sm-12 col-md-12 col-lg-8">
                <!-- Jamais imprimé : ce que le commercial peut promettre, pour le devis entier. -->
                <div class="ix-trade-totals ix-delivery-summary mb-3" v-if="showsAvailability && delivery">
                    <h3 class="ix-delivery-summary-title">Délai de livraison</h3>
                    <template v-if="delivery.latest">
                        <div class="d-flex justify-content-between">
                            <span class="ix-text-secondary">Ligne la plus tardive</span>
                            <span>{{ delivery.latest }}</span>
                        </div>
                        <div class="d-flex justify-content-between">
                            <span class="ix-text-secondary">Délai au plus tôt</span>
                            <span>
                                <span class="ix-text-bold">{{ delivery.days }} j</span>
                                <span class="ix-text-secondary" v-if="delivery.unknown.length > 0"
                                      v-b-tooltip="{ title: 'Sans délai renseigné :\n' + delivery.unknown.join('\n'), trigger: 'hover', placement: 'top', boundary: 'window', customClass: 'ix-line-tooltip' }"> incomplet</span>
                            </span>
                        </div>
                    </template>
                    <div v-else-if="delivery.unknown.length > 0" class="d-flex justify-content-between">
                        <span class="ix-text-secondary">Délai au plus tôt</span>
                        <span class="ix-text-secondary"
                              v-b-tooltip="{ title: 'Sans délai renseigné :\n' + delivery.unknown.join('\n'), trigger: 'hover', placement: 'top', boundary: 'window', customClass: 'ix-line-tooltip' }">Non renseigné</span>
                    </div>
                    <div v-else class="ix-text-green">Disponible immédiatement</div>
                </div>

                <!-- Jamais imprimé : ce que le calcul du port a retenu, et pourquoi. -->
                <div class="ix-trade-totals ix-delivery-summary mb-3" v-if="shippingEstimate && (shippingEstimate.counted > 0 || shippingEstimate.missing.length > 0 || shippingEstimate.goods > 0)">
                    <h3 class="ix-delivery-summary-title">Poids et transport</h3>
                    <div class="ix-text-secondary mb-1"><small>Selon les conditions et la grille actuelles.</small></div>
                    <div class="d-flex justify-content-between">
                        <span class="ix-text-secondary">Poids total</span>
                        <span>
                            <i class="far fa-exclamation-triangle ix-text-orange mr-1" v-if="shippingEstimate.missing.length > 0"
                               v-b-tooltip="{ title: 'Poids incomplet, sans poids renseigné :\n' + shippingEstimate.missing.join('\n'), trigger: 'hover', placement: 'top', boundary: 'window', customClass: 'ix-line-tooltip' }"></i>
                            <span class="ix-text-bold">{{ formatKg(shippingEstimate.weight) }} kg</span>
                        </span>
                    </div>
                    <div class="d-flex justify-content-between">
                        <span class="ix-text-secondary">Zone</span>
                        <span v-if="shippingEstimate.zone">{{ shippingEstimate.zone.name }}</span>
                        <span class="ix-text-orange" v-else>{{ shippingEstimate.location ? 'Aucune zone pour ' + shippingEstimate.location : 'Adresse non renseignée' }}</span>
                    </div>
                    <div class="d-flex justify-content-between" v-if="shippingEstimate.bracket">
                        <span class="ix-text-secondary">Tranche</span>
                        <span>{{ shippingEstimate.bracket.label }}<template v-if="shippingEstimate.bracket.mode"> · {{ shippingEstimate.bracket.mode }}</template></span>
                    </div>
                    <div class="d-flex justify-content-between" v-if="shippingEstimate.bracket">
                        <span class="ix-text-secondary">Estimation grille</span>
                        <span>{{ shippingEstimate.grid_amount !== null ? currency(shippingEstimate.grid_amount) + ' HT' : 'Sur devis' }}</span>
                    </div>
                    <div class="d-flex justify-content-between" v-if="shippingEstimate.free_shipping">
                        <span class="ix-text-secondary">Franco à {{ currency(shippingEstimate.free_shipping.threshold) }} HT</span>
                        <span class="ix-text-green" v-if="shippingEstimate.free_shipping.reached">Atteint</span>
                        <span v-else>Encore {{ currency(shippingEstimate.free_shipping.shortfall) }} HT</span>
                    </div>
                    <div class="d-flex justify-content-between">
                        <span class="ix-text-secondary">Port</span>
                        <span>
                            <span class="ix-text-green ix-text-bold" v-if="shippingEstimate.source === 'free'">Offert</span>
                            <template v-else-if="shippingEstimate.port !== null">
                                <span class="ix-text-bold">{{ currency(shippingEstimate.port) }} HT</span>
                                <span class="ix-text-secondary">{{ shippingEstimate.source === 'grid' ? '(grille)' : '(forfait' + (shippingEstimate.reason ? ', ' + shippingEstimate.reason : '') + ')' }}</span>
                            </template>
                            <span class="ix-text-orange" v-else>À saisir<template v-if="shippingEstimate.reason"> ({{ shippingEstimate.reason }})</template></span>
                        </span>
                    </div>
                    <div class="d-flex justify-content-between" v-if="shippingDivergence">
                        <span class="ix-text-secondary">Ligne de port à {{ currency(shippingLine.amount) }}</span>
                        <button type="button" class="ix-btn link p-0" @click="applyShippingEstimate" v-if="editable">Appliquer {{ currency(shippingEstimate.port) }}</button>
                    </div>
                    <div class="ix-text-secondary mt-1" v-if="shippingEstimate.weekday">
                        Franco le {{ shippingEstimate.weekday.toLowerCase() }} : port offert si livré ce jour.
                    </div>
                </div>

                <div class="custom-control custom-switch" v-if="hasKit">
                    <input type="checkbox" class="custom-control-input" id="show_kit_details" v-model="showKitDetails" :disabled="!editable">
                    <label class="custom-control-label" for="show_kit_details">Détailler les articles composés sur le PDF</label>
                </div>
                <!-- La seule trace de la disponibilité hors écran : une mention par ligne, sans quantité ni date. -->
                <div class="custom-control custom-switch" v-if="showsAvailability">
                    <input type="checkbox" class="custom-control-input" id="show_availability" v-model="showAvailability" :disabled="!editable">
                    <label class="custom-control-label" for="show_availability">Afficher la disponibilité sur le PDF</label>
                </div>
            </div>
            <div class="col-sm-12 col-md-12 col-lg-4">
                <div class="ix-text-orange text-right mb-2" v-if="minimumShortfall">
                    <i class="far fa-exclamation-triangle mr-1"></i>
                    Minimum de commande non atteint : {{ currency(minimumShortfall.goods) }} HT sur {{ currency(minimumShortfall.minimum) }} HT
                </div>
                <div class="ix-trade-totals">
                    <table class="ix-table ix-table-transparent">
                        <tbody>
                        <tr>
                            <td>Total HT</td>
                            <td class="text-right">{{ currency(total_ht) }}</td>
                        </tr>
                        <tr>
                            <td>
                                Remise globale
                                <div class="input-group input-group-sm" style="width: 120px;">
                                    
                                    <input type="number" class="form-control text-center" name="discount" v-model="discount" required min="0" id="discount" :disabled="editable ? false : true" step="0.001">
                                    <input type="hidden" class="form-control text-center" name="discount" v-model="discount" required min="0" id="discount" v-if="editable ? false : true" step="0.001">
                                    <div class="input-group-append">
                                        <span class="input-group-text" id="inputGroup-sizing-sm">%</span>
                                    </div>
                                </div>
                            </td>
                            <td class="text-right">- {{ currency(total_discount) }}</td>
                        </tr>
                        <tr>
                            <td class="ix-text-bold">
                                Net commercial
                            </td>
                            <td class="text-right">
                                <span class="ix-text-bold ix-text-xlarge">{{ currency(total_after_discount) }}</span>
                            </td>
                        </tr>
                        <tr v-if="total_eco_participation != 0">
                            <td>Éco-participation</td>
                            <td class="text-right">{{ currency(total_eco_participation) }}</td>
                        </tr>
                        <tr>
                            <td>
                                Total TVA
                                <div>
                                    <span class="ix-text-bold">Autoliquidation</span>
                                    <div class="form-check form-check-inline">
                                        <input class="form-check-input" type="radio" name="is_autoliquidation" id="is_autoliquidation_false" value="0" v-model="isAutoliquidation" :disabled="editable ? false : true">
                                        <label class="form-check-label" for="is_autoliquidation_false">Non</label>
                                    </div>
                                    <div class="form-check form-check-inline">
                                        <input class="form-check-input" type="radio" name="is_autoliquidation" id="is_autoliquidation_true" value="1" v-model="isAutoliquidation" :disabled="editable ? false : true">
                                        <label class="form-check-label" for="is_autoliquidation_true">Oui</label>
                                    </div>

                                    <input type="hidden" class="form-control text-center" name="is_autoliquidation" v-model="isAutoliquidation"  id="discount" v-if="editable ? false : true">
                                </div>
                            </td>
                            <td class="text-right">{{ currency(total_vat) }}</td>
                        </tr>
                        <tr>
                            <td>Total TTC</td>
                            <td class="text-right">{{ currency(total_ttc) }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <article-quick-create-modal v-if="canCreate" ref="articleModal" :form-route="articleModalRoute"></article-quick-create-modal>
    </div>
</template>

<script>
    import LineForm from "./LineForm";
    import KitDetailRow from "./KitDetailRow";
    import ArticleQuickCreateModal from "../stock/ArticleQuickCreateModal";
    import draggable from 'vuedraggable';
    import Swal from "sweetalert2";
    import { blockingBreach, limitBreach, resolveEntry } from '../../pricing';
    import { lineAvailability, deliverySummary, documentDemand } from './lineAvailability';
    import { estimateShipping } from './shippingEstimate';

    export default {
        name: 'line-table-form',
        props: ['suggestionsRoute', 'pricingRoute', 'kitsRoute', 'oldLines', 'oldAutoliquidation', 'oldShowKitDetails', 'oldShowAvailability', 'oldDiscount', 'model', 'id', 'tvaGlobal', 'isEditable', 'articleModalRoute', 'canCreateArticle', 'insightsRoute', 'availabilityRoute', 'lotMainStyle', 'lotDetailStyle', 'hiddenLinesEnabled', 'shippingRoute', 'conditionsRoute'],
        components : {
            LineForm,
            KitDetailRow,
            ArticleQuickCreateModal,
            draggable
        },
        data() {
            return {
                // Le formulaire du document, dont on grise l'enregistrement.
                submitForm: null,
                loading: true,
                discount: 0,
                isAutoliquidation: 0,
                showKitDetails: false,
                showAvailability: false,
                // Prix d'achat et date du prix tarif par article, déjà filtrés par le serveur.
                insights: {},
                insightsRequested: {},
                // Stock, suivi et délai retenu des articles simples ; un kit lit les siens dans line.kit.
                availabilityArticles: {},
                availabilityRequested: {},
                lines: [],
                globalTva: this.tvaGlobal,
                editable: true,
                companyId: null,
                recomputeToken: 0,
                // Calcul du port (devis) : contexte du serveur et poids des articles déjà demandés.
                shippingContext: null,
                shippingWeights: {},
                shippingRequest: 0,
                // Une ligne de port n'apparaît d'elle-même que sur un devis neuf, ou après que le franco l'a retirée.
                shippingAutoAllowed: false,
                shippingInitialized: false,
                // Montant minimum de commande de la société (devis, conditions commerciales actives).
                minOrderAmount: null,
            };
        },
        watch: {
            // Les lignes d'un document rouvert arrivent après le montage : leurs paliers et
            // leurs seuils se demandent une fois qu'elles sont là.
            loading: function (value) {
                if (!value) {
                    this.loadArticleData();
                    this.loadKits();
                    this.loadShipping();
                    this.loadConditions();
                }
            },
            insightArticleIds: function (ids) {
                this.loadInsights(ids);
                this.loadAvailability(ids);
                if (ids.some(id => !(id in this.shippingWeights))) {
                    this.loadShipping();
                }
            },
            blockedLines: function () {
                this.refreshSubmitButtons();
            },
            shippingEstimate: function () {
                this.syncShippingLine();
            }
        },
        computed: {
            /** Le « + » des lignes : création d'article à la volée, avec articles_manage. */
            /** Les articles de la grille, hors éco-participations : un nouvel article déclenche ses repères. */
            insightArticleIds() {
                return [...new Set(this.lines
                    .filter(line => line.article_id && !line.is_eco_participation && !line.is_title)
                    .map(line => line.article_id))];
            },
            /** Stock et disponibilité : devis seulement, réglage actif (la route n'est passée qu'à cette condition). */
            showsAvailability() {
                return !!this.availabilityRoute && this.model == 'quote';
            },
            columnCount() {
                return (this.isAutoliquidation == 1 ? 9 : 10) + (this.showsAvailability ? 2 : 0);
            },
            /** La disponibilité de chaque ligne, recalculée à chaque quantité. */
            availabilities() {
                if (!this.showsAvailability) {
                    return {};
                }

                const result = {};
                this.lines.forEach(line => {
                    result[line.uniq] = lineAvailability(line, this.availabilityArticles, this.demand);
                });

                return result;
            },
            /** Le besoin de chaque article sur tout le devis : deux lignes, ou un kit et l'article seul, puisent dans le même stock. */
            demand() {
                return this.showsAvailability ? documentDemand(this.lines) : null;
            },
            delivery() {
                return deliverySummary(this.lines.map(line => ({ line: line, availability: this.availabilities[line.uniq] })));
            },
            /** Le calcul du port : devis seulement, interrupteur ouvert (la route n'est passée qu'à cette condition). */
            showsShipping() {
                return !!this.shippingRoute && this.model == 'quote';
            },
            shippingLine() {
                return this.lines.find(line => line.is_shipping) || null;
            },
            /** Toujours proposé : l'interrupteur coupe le calcul, pas la ligne de port. Sans calcul, elle se pose à 0 €. */
            showsShippingButton() {
                return this.editable;
            },
            /** Pourquoi le bouton est grisé ; null s'il peut servir. */
            shippingButtonBlocker() {
                if (this.shippingLine) return 'Le document a déjà une ligne de frais de port.';
                if (this.shippingEstimate && this.shippingEstimate.source === 'free') return 'Franco atteint : le port est offert.';
                return null;
            },
            shippingEstimate() {
                if (!this.showsShipping || !this.shippingContext) {
                    return null;
                }

                return estimateShipping(this.lines, this.shippingContext, this.shippingWeights);
            },
            /** Le manque sous le minimum de commande, dès la première ligne d'article ; null sinon. */
            minimumShortfall() {
                if (this.minOrderAmount === null || !this.lines.some(line => line.article_id && !line.is_title)) {
                    return null;
                }

                const goods = this.lines
                    .filter(line => line.is_title != 1 && !line.is_eco_participation && !line.is_shipping)
                    .reduce((sum, line) => sum + (parseFloat(line.total_after_discount) || 0), 0);

                return goods < this.minOrderAmount ? { goods: goods, minimum: this.minOrderAmount } : null;
            },
            /** Une ligne de port saisie à la main qui ne vaut plus ce que le calcul propose. */
            shippingDivergence() {
                const line = this.shippingLine;
                const estimate = this.shippingEstimate;

                return !!line && !!estimate && estimate.port !== null && !this.isShippingAuto(line)
                    && Math.abs((parseFloat(line.amount) || 0) - estimate.port) > 0.005;
            },
            /** L'interrupteur du détail des kits sur le PDF n'a de sens qu'avec un kit dans la grille. */
            hasKit() {
                return this.lines.some(line => !line.is_title && line.kit);
            },
            canCreate() {
                return !!this.articleModalRoute && (this.canCreateArticle === true || this.canCreateArticle === 'true');
            },
            /**
             * Une ligne suivie de ses éco-participations : l'unité du glisser-déposer. La liste
             * plate reste la source de vérité, dans l'ordre posté ; l'index est celui de la ligne.
             */
            groups: function() {
                return this.groupLines(this.lines);
            },
            /** Les lignes qu'un seuil de vente refuse, motif de déblocage déduit. */
            blockedLines: function() {
                return this.lines.filter(line => blockingBreach(line));
            },
            /**
             * Combien de lignes portent chaque article, et pour quelle quantité totale. Le
             * calcul est local et ne coûte aucune requête : il sert au rappel de non-cumul,
             * les quantités ne s'additionnant pas pour le déclenchement d'un palier.
             */
            articleQuantities: function() {
                const totals = {};

                this.lines.forEach(line => {
                    if (line.is_eco_participation || line.is_title || !line.article_id) {
                        return;
                    }

                    const current = totals[line.article_id] || { count: 0, quantity: 0 };

                    totals[line.article_id] = {
                        count: current.count + 1,
                        quantity: current.quantity + (parseFloat(line.quantity) || 0),
                    };
                });

                return totals;
            },
            total_ht: function() {
                var sum = 0;
                this.lines.forEach(line => {
                    if (!line.is_eco_participation) sum += parseFloat(line.total_ht) || 0;
                });
                return sum;
            },
            total_eco_participation: function() {
                var sum = 0;
                this.lines.forEach(line => {
                    if (line.is_eco_participation) sum += parseFloat(line.total_ht) || 0;
                });
                return sum;
            },
            total_discount: function() {
                var sum = 0;
                this.lines.forEach(line => {
                    if (!line.is_eco_participation) sum += parseFloat(line.total_discount) || 0;
                });
                return sum;
            },
            total_after_discount: function() {
                var sum = 0;
                this.lines.forEach(line => {
                    if (!line.is_eco_participation) sum += parseFloat(line.total_after_discount) || 0;
                });
                return sum;
            },
            total_vat: function() {
                var sum = 0;
                this.lines.forEach(line => sum += line.total_vat);
                return Math.round(sum * 100) / 100;
            },
            total_ttc: function() {
                var sum = 0;
                this.lines.forEach(line => sum += line.total_ttc);
                return Math.round(sum * 100) / 100;
            },
            can_add_line_under_total: function(){
                var can = false;
                can = this.lines.filter((element) => element.amount != 0).length > 0 ? true : false;
                return can;
            },
            hideableLineUniqs: function() {
                var hideable = {};
                var lotMainStyle = parseInt(this.lotMainStyle);
                if (this.model != 'quote' || !lotMainStyle || this.hiddenLinesEnabled === false) {
                    return hideable;
                }

                var inLotDetail = false;
                this.lines.forEach(line => {
                    var isTitle = line.is_title == 1;
                    if (parseInt(line.line_type_style) === lotMainStyle) {
                        inLotDetail = !isTitle;
                        return;
                    }

                    var isUnderTotal = !!parseFloat(line.under_total);
                    var isEcoParticipation = line.is_eco_participation == 1;
                    if (inLotDetail && isTitle && !isUnderTotal && !isEcoParticipation) {
                        hideable[line.uniq] = true;
                    }
                });

                return hideable;
            },
            protectedArticleLineUniqs: function() {
                var parentIds = {};
                var parentUniqs = {};
                this.lines.forEach(line => {
                    if (line.is_eco_participation == 1) {
                        if (line.eco_parent_line_id) {
                            parentIds[line.eco_parent_line_id] = true;
                        }
                        if (line.eco_parent_uniq) {
                            parentUniqs[line.eco_parent_uniq] = true;
                        }
                    }
                });

                var lotMainStyle = parseInt(this.lotMainStyle);
                var lotDetailStyle = parseInt(this.lotDetailStyle);
                var inPricedLot = false;
                var protectedLines = {};
                this.lines.forEach(line => {
                    var isEcoParticipation = line.is_eco_participation == 1;
                    if (lotMainStyle && parseInt(line.line_type_style) === lotMainStyle) {
                        inPricedLot = line.is_title != 1;
                        return;
                    }

                    var isEcoParent = !isEcoParticipation && ((line.id && parentIds[line.id]) || parentUniqs[line.uniq]);
                    var isLotDetailArticle = inPricedLot && lotDetailStyle && line.is_title != 1 && !isEcoParticipation
                        && parseInt(line.line_type_style) === lotDetailStyle && !parseFloat(line.amount) && line.article_id;

                    if (isEcoParent || isLotDetailArticle) {
                        protectedLines[line.uniq] = true;
                    }
                });

                return protectedLines;
            }
        },
        methods : {
            /** Contexte du port et poids des articles de la grille ; la dernière réponse demandée l'emporte. */
            loadShipping() {
                if (!this.showsShipping || this.loading) {
                    return;
                }

                const token = ++this.shippingRequest;
                const params = new URLSearchParams();
                if (this.companyId) params.append('company_id', this.companyId);
                const addressId = $('#address_id').val();
                const deliveryAddressId = $('#delivery_address_id').val();
                if (addressId) params.append('address_id', addressId);
                if (deliveryAddressId) params.append('delivery_address_id', deliveryAddressId);
                this.insightArticleIds.forEach(id => params.append('article_ids[]', id));

                fetch(this.shippingRoute + '?' + params.toString(), {
                    ...{ method: 'GET' },
                    ...this.getHttpJsonRequestHeaders()
                })
                .then(response => response.ok ? response.json() : Promise.reject(response))
                .then(data => {
                    if (token !== this.shippingRequest) return;
                    this.shippingWeights = Object.assign({}, this.shippingWeights, data.weights || {});
                    this.shippingContext = { conditions: data.conditions, zone: data.zone, location: data.location, brackets: data.brackets };
                })
                .catch(() => {});
            },
            loadConditions() {
                if (!this.conditionsRoute || this.model != 'quote') return;

                if (!this.companyId) {
                    this.minOrderAmount = null;
                    return;
                }

                fetch(this.conditionsRoute + '?company_id=' + this.companyId, {
                    ...{ method: 'GET' },
                    ...this.getHttpJsonRequestHeaders()
                })
                .then(response => response.ok ? response.json() : Promise.reject(response))
                .then(data => { this.minOrderAmount = data.min_order_amount; })
                .catch(() => {});
            },
            isShippingAuto(line) {
                return line.shipping_auto_amount !== null && line.shipping_auto_amount !== undefined
                    && Math.abs((parseFloat(line.amount) || 0) - line.shipping_auto_amount) < 0.005
                    && (parseFloat(line.quantity) || 0) === 1;
            },
            /** Les totaux d'une ligne dont le prix change hors de sa saisie, comme LineForm les calcule. */
            computeLineTotals(line) {
                const price = (parseFloat(line.quantity) || 0) * (parseFloat(line.amount) || 0);
                line.total_ht = price - (parseFloat(line.discount) ? price * parseFloat(line.discount) / 100 : 0);
                line.total_discount = this.discount ? line.total_ht * this.discount / 100 : 0;
                line.total_after_discount = line.total_ht - line.total_discount;
                line.total_vat = parseFloat((line.total_after_discount * ((parseFloat(line.vat) || 0) / 100)).toFixed(2));
                line.total_ttc = parseFloat((line.total_after_discount + line.total_vat).toFixed(2));

                if (this.model == 'creditnote') {
                    line.total_ht = line.total_ht * -1;
                    line.total_after_discount = line.total_after_discount * -1;
                    line.total_vat = line.total_vat * -1;
                    line.total_ttc = line.total_ttc * -1;
                }
            },
            /** Pose la ligne de port en fin de grille, avant la ligne vierge de saisie s'il y en a une. */
            addShippingLine(auto) {
                this.addRow(null);
                const line = this.lines.pop();
                const port = this.shippingEstimate ? this.shippingEstimate.port : null;

                line.is_shipping = true;
                line.designation = 'Frais de port';
                line.amount = port !== null ? port : 0;
                line.shipping_auto_amount = port !== null && this.showsShipping ? port : null;
                this.computeLineTotals(line);

                const last = this.lines[this.lines.length - 1];
                const lastIsBlank = last && !last.is_title && !last.article_id && !last.is_shipping && !last.designation && !(parseFloat(last.amount) || 0);
                this.lines.splice(lastIsBlank ? this.lines.length - 1 : this.lines.length, 0, line);

                if (!auto) {
                    this.shippingAutoAllowed = true;
                }
            },
            applyShippingEstimate() {
                const line = this.shippingLine;
                if (!line || !this.shippingEstimate || this.shippingEstimate.port === null) return;

                line.quantity = 1;
                line.amount = this.shippingEstimate.port;
                line.shipping_auto_amount = this.shippingEstimate.port;
                this.computeLineTotals(line);
            },
            /**
             * Une ligne automatique suit le calcul et disparaît au franco ; une ligne retouchée n'est
             * jamais modifiée. À l'ouverture, la ligne enregistrée est automatique si son prix est
             * celui du calcul : un devis rouvert ne change pas de montant sans qu'on le demande.
             */
            syncShippingLine() {
                const estimate = this.shippingEstimate;
                if (!estimate || !this.editable) return;

                const line = this.shippingLine;

                if (!this.shippingInitialized) {
                    this.shippingInitialized = true;
                    if (line && estimate.port !== null && Math.abs((parseFloat(line.amount) || 0) - estimate.port) < 0.005 && (parseFloat(line.quantity) || 0) === 1) {
                        line.shipping_auto_amount = estimate.port;
                    }
                }

                if (line) {
                    if (!this.isShippingAuto(line)) return;

                    if (estimate.port === null || estimate.port <= 0) {
                        this.lines.splice(this.lines.indexOf(line), 1);
                        this.shippingAutoAllowed = true;
                    } else if (Math.abs(line.shipping_auto_amount - estimate.port) >= 0.005) {
                        line.amount = estimate.port;
                        line.shipping_auto_amount = estimate.port;
                        this.computeLineTotals(line);
                    }
                    return;
                }

                if (this.shippingAutoAllowed && estimate.port !== null && estimate.port > 0 && estimate.goods > 0) {
                    this.addShippingLine(true);
                }
            },
            formatKg(value) {
                return (parseFloat(value) || 0).toLocaleString('fr-FR', { maximumFractionDigits: 3 });
            },
            openArticleModal(event) {
                this.$refs.articleModal.open(event.source, event.done);
            },
            /** Chaque éco-participation rejoint la ligne qu'elle accompagne, où qu'elle soit dans la liste. */
            groupLines(lines) {
                const groups = [];
                const byParent = {};

                lines.forEach((line, index) => {
                    const item = { line: line, index: index };
                    const parent = line.is_eco_participation
                        ? (byParent[line.eco_parent_uniq] || (line.eco_parent_line_id && byParent['id' + line.eco_parent_line_id]))
                        : null;

                    if (parent) {
                        parent.items.push(item);
                        return;
                    }

                    const group = { key: line.uniq, items: [item] };
                    groups.push(group);
                    byParent[line.uniq] = group;
                    if (line.id) {
                        byParent['id' + line.id] = group;
                    }
                });

                return groups;
            },
            flattenGroups(groups) {
                return [].concat(...groups.map(group => group.items.map(item => item.line)));
            },
            /** L'ordre posté suit l'affichage : syncLines rattache une éco nouvelle à la ligne qui la précède. */
            regroupLines() {
                this.lines = this.flattenGroups(this.groupLines(this.lines));
            },
            addRow: function (line) {
                var data = {
                    id: null,
                    uniq: Math.random().toString(36).substr(2, 9),
                    is_title: 0,
                    reference: '',
                    designation: '',
                    quantity: 1,
                    amount: 0,
                    discount: 0,
                    vat: this.isAutoliquidation == 0 ? this.globalTva : 0,
                    total_ht: 0,
                    total_discount: 0,
                    total_after_discount: 0,
                    total_vat: 0,
                    total_ttc: 0,
                    under_total: null,
                    article_id: null,
                    parent_id: null,
                    line_type_style: null,
                    is_hidden_from_client: false,
                    // Champs éco-participation
                    is_eco_participation: false,
                    eco_category_id: null,
                    eco_parent_line_id: null,
                    eco_parent_uniq: null,
                    eco_rate_amount: null,
                    eco_unit_amount: null,
                    // Origine de la remise, connue le temps de la saisie et jamais postée.
                    // pricing porte les paliers résolus par le serveur.
                    pricing: null,
                    suggested_discount: null,
                    // Déclaré ici, comme les autres : Vue ne rend pas réactive une propriété
                    // posée après la création de la ligne, et la pastille ne suivrait pas.
                    suggested_field: null,
                    suggested_label: null,
                    // Prix public actuel de l'article, référence de la pastille du PU.
                    public_price: null,
                    // Seuils de vente de l'article, et motif de déblocage le cas échéant.
                    minimum_order_quantity: null,
                    minimum_selling_price: null,
                    limit_override_for: null,
                    limit_override_reason: null,
                    // Détail du kit (composition, stock), connu le temps de la saisie et jamais posté.
                    kit: null,
                    kit_open: false,
                    // Ligne de frais de port, et montant posé par le calcul tant que personne n'y a touché.
                    is_shipping: false,
                    shipping_auto_amount: null
                }

                if (line != null) {
                    const isEcoParticipation = line.is_eco_participation === true || line.is_eco_participation === 1 || line.is_eco_participation === '1'
                    data.id = line.id
                    data.is_title = line.is_title
                    data.reference = line.reference
                    data.designation = line.designation
                    data.description = line.description
                    data.quantity = line.quantity
                    data.amount = line.amount
                    data.unit = line.unit
                    data.discount = line.discount
                    data.vat = line.vat
                    data.under_total = line.under_total,
                    data.article_id  = line.article_id
                    data.parent_id = line.parent_id
                    data.line_type_style = line.line_type_style || null
                    data.is_hidden_from_client = line.is_hidden_from_client == 1
                    // Champs éco-participation
                    data.is_eco_participation = isEcoParticipation
                    data.eco_category_id = line.eco_category_id || null
                    data.eco_parent_line_id = line.eco_parent_line_id || null
                    data.eco_parent_uniq = line.eco_parent_uniq || null
                    data.eco_rate_amount = line.eco_rate_amount || null
                    data.limit_override_reason = line.limit_override_reason || null
                    data.eco_unit_amount = line.eco_unit_amount || null
                    data.is_shipping = line.is_shipping === true || line.is_shipping === 1 || line.is_shipping === '1'

                    if (data.is_eco_participation && data.eco_unit_amount === null) {
                        data.eco_unit_amount = parseFloat(line.amount) || 0
                    }
                }

                this.lines.push(data)
            },
            addUnderTotalRow(){
                var data = {
                    id: null,
                    uniq: Math.random().toString(36).substr(2, 9),
                    is_title: 1,
                    reference: '',
                    designation: '',
                    quantity: 1,
                    amount: 0,
                    discount: 0,
                    vat: this.isAutoliquidation == 0 ? this.globalTva : 0,
                    total_ht: 0,
                    total_discount: 0,
                    total_after_discount: 0,
                    total_vat: 0,
                    total_ttc: 0,
                    under_total: 0,
                }

                var sum = 0;

                this.lines.forEach(line => {{
                    if(line.is_title && line.under_total && line.under_total != null)
                        sum = 0
                    else    
                        sum += parseFloat(line.total_after_discount);
                }})

                data.under_total = sum;
                data.designation = 'Sous total HT : ' + this.currency(sum)

                this.lines.push(data);
            },
            deleteRow: function (index) {
                const lineToDelete = this.lines[index];

                // Retirée à la main, la ligne de port ne revient pas d'elle-même : le bouton la repropose.
                if (lineToDelete.is_shipping) {
                    this.shippingAutoAllowed = false;
                }
                
                // Si on supprime une ligne article, supprimer ses lignes éco
                if (!lineToDelete.is_eco_participation && lineToDelete.article_id) {
                    this.removeEcoLinesForParent(lineToDelete.uniq);
                }
                
                this.lines.splice(index, 1)
                if (this.lines.length == 0) {
                    this.addRow()
                }

                this.computeUnderTotalLine();
            },
            checkIfNewRowNeeded: function (index) {
               if(this.editable){
                   if (this.lines.length > 0) {
                        if (this.lines.length - 1 == index) {
                            this.addRow()
                        }
                    }
               }
            },
            computeUnderTotalLine(event){
                var sum = 0;
                this.lines.forEach(line => {{
                    sum += parseFloat(line.total_ht)
                    if(line.is_title && line.under_total  && line.under_total != null){
                        line.under_total = sum;
                        line.designation = 'Sous total HT : ' + this.currency(sum)
                        sum = 0;
                    }
                }})
            },
            /**
             * Les positions de Sortable ne comptent que les groupes : le calcul de vuedraggable,
             * faussé par l'en-tête de la table, laissait parfois un groupe vide dans la liste.
             */
            moveGroup(evt) {
                const groups = this.groupLines(this.lines);
                const from = evt.oldDraggableIndex;
                const to = evt.newDraggableIndex;

                if (from === undefined || to === undefined || from === to || !groups[from] || to < 0 || to >= groups.length) {
                    return;
                }

                groups.splice(to, 0, groups.splice(from, 1)[0]);
                this.lines = this.flattenGroups(groups);
                this.moveLine();
            },
            moveLine(){
                var sum = 0;
                setTimeout(() => {
                      this.lines.forEach((line,index) => {{
                        sum += parseFloat(line.total_after_discount)
                        if(line.is_title && line.under_total != null){
                            line.under_total = sum;
                            line.designation = 'Sous total HT : ' + this.currency(sum)
                            sum = 0;
                            if(line.under_total == 0){
                                this.lines.splice(index , 1);
                            }   
                        }
                        
                    }})
                }, 100);
              
            },
            getLines: async function (route) {
                this.loading = true;
                fetch(route, {
                    ...{
                        method: 'GET'
                    },
                    ...this.getHttpJsonRequestHeaders()
                }).then((response) => {
                    return response.json();
                }).then((data) => {
                    data.forEach(line => {
                        this.addRow(line)
                    })
                    this.regroupLines()
                    if(this.editable){
                        this.addRow(null)
                    }
                        
                    this.loading = false
                }).catch(error => {
                    console.log(error)
                });
            },
            /**
             * Les lignes que la cascade peut reprendre : un article vendable, et rien qui
             * ait été saisi à la main. Un prix tapé volontairement reste hors du lot.
             */
            pricingLines() {
                return this.lines.filter(line => {
                    if (line.is_eco_participation || line.is_title || !line.article_id) {
                        return false;
                    }

                    return !this.isEditedByHand(line);
                });
            },
            isEditedByHand(line) {
                const differs = (value, suggested) => suggested !== null && suggested !== undefined
                    && Math.abs((parseFloat(value) || 0) - parseFloat(suggested)) >= 0.0001;

                return differs(line.discount, line.suggested_discount);
            },
            /**
             * La société change en cours de saisie : ni le profil ni les règles négociées
             * des articles déjà posés ne sont ceux du client. On les redemande pour
             * proposer la mise à jour.
             */
            refreshGridDiscounts() {
                if (!this.pricingRoute || !this.editable) {
                    return;
                }

                // L'autocomplete vide le champ avant d'y poser la nouvelle société : sans
                // client, on ne sait rien, et surtout on ne remet aucune remise à zéro.
                if (!this.companyId) {
                    return;
                }

                const lines = this.pricingLines();
                if (lines.length === 0) {
                    return;
                }

                this.fetchPricing(lines)
                    .then(data => this.askGridDiscountsUpdate(data))
                    .catch(error => console.log(error));
            },
            /**
             * Les lignes d'un document rouvert viennent de la base, pas d'une suggestion :
             * on apprend leurs paliers et leurs seuils sans rien réécrire, sinon rouvrir un
             * devis en changerait les prix.
             */
            loadArticleData() {
                if (!this.pricingRoute || !this.companyId) {
                    return;
                }

                const lines = this.pricingLines();
                if (lines.length === 0) {
                    return;
                }

                this.fetchPricing(lines)
                    .then(data => this.applyArticleData(data.articles || {}))
                    .catch(error => console.log(error));
            },
            /**
             * Le détail des kits d'un document rouvert : composition figée des lignes enregistrées,
             * composition du jour des autres (saisie refusée).
             */
            loadKits() {
                if (!this.kitsRoute) {
                    return;
                }

                const lines = this.lines.filter(line => line.article_id && !line.is_eco_participation && !line.is_title);
                if (lines.length === 0) {
                    return;
                }

                const params = new URLSearchParams();
                lines.forEach(line => {
                    if (line.id) {
                        params.append('line_ids[]', line.id);
                    }
                    params.append('article_ids[]', line.article_id);
                });

                fetch(this.kitsRoute + '?' + params.toString(), {
                    ...{ method: 'GET' },
                    ...this.getHttpJsonRequestHeaders()
                }).then(response => response.json()).then(data => {
                    lines.forEach(line => {
                        const kit = (line.id && (data.lines || {})[line.id]) || (data.articles || {})[line.article_id] || null;

                        line.kit = kit;
                        line.kit_open = !!kit && this.isKitOpen(line);
                    });
                }).catch(error => console.log(error));
            },
            /** L'état ouvert d'un kit tient le temps de la session, pour les lignes enregistrées. */
            kitOpenKey(line) {
                return line.id ? 'kit-open:' + this.model + ':' + this.id + ':' + line.id : null;
            },
            isKitOpen(line) {
                const key = this.kitOpenKey(line);

                try {
                    return key !== null && sessionStorage.getItem(key) === '1';
                } catch (e) {
                    return false;
                }
            },
            rememberKitOpen(line) {
                const key = this.kitOpenKey(line);

                try {
                    if (key !== null) {
                        sessionStorage.setItem(key, line.kit_open ? '1' : '0');
                    }
                } catch (e) {
                    // Stockage indisponible : l'état ne survit pas à la page, sans autre effet.
                }
            },
            /** Chaque article n'est demandé qu'une fois : ses repères ne changent pas en cours de saisie. */
            loadInsights(ids) {
                if (!this.insightsRoute) {
                    return;
                }

                const missing = ids.filter(id => !this.insightsRequested[id]);
                if (missing.length === 0) {
                    return;
                }

                const params = new URLSearchParams();
                missing.forEach(id => {
                    this.insightsRequested[id] = true;
                    params.append('article_ids[]', id);
                });

                fetch(this.insightsRoute + '?' + params.toString(), {
                    ...{ method: 'GET' },
                    ...this.getHttpJsonRequestHeaders()
                }).then(response => response.json()).then(data => {
                    this.insights = Object.assign({}, this.insights, data.articles || {});
                }).catch(error => console.log(error));
            },
            /** Chaque article n'est demandé qu'une fois : la quantité se compare au stock dans le navigateur. */
            loadAvailability(ids) {
                if (!this.showsAvailability) {
                    return;
                }

                const missing = ids.filter(id => !this.availabilityRequested[id]);
                if (missing.length === 0) {
                    return;
                }

                const params = new URLSearchParams();
                missing.forEach(id => {
                    this.availabilityRequested[id] = true;
                    params.append('article_ids[]', id);
                });

                fetch(this.availabilityRoute + '?' + params.toString(), {
                    ...{ method: 'GET' },
                    ...this.getHttpJsonRequestHeaders()
                }).then(response => response.json()).then(data => {
                    this.availabilityArticles = Object.assign({}, this.availabilityArticles, data.articles || {});
                }).catch(error => console.log(error));
            },
            fetchPricing(lines) {
                const params = new URLSearchParams();
                params.append('company_id', this.companyId);
                [...new Set(lines.map(line => line.article_id))].forEach(id => params.append('article_ids[]', id));

                return fetch(this.pricingRoute + '?' + params.toString(), {
                    ...{ method: 'GET' },
                    ...this.getHttpJsonRequestHeaders()
                }).then(response => response.json());
            },
            /** Ce que l'article impose, indépendamment de la valeur posée sur la ligne. */
            applyArticleData(articles) {
                this.pricingLines().forEach(line => {
                    const entry = articles[line.article_id] || {};

                    line.pricing = entry.pricing || null;
                    line.public_price = entry.public_price !== undefined ? entry.public_price : null;
                    line.minimum_order_quantity = entry.minimum_order_quantity !== undefined
                        ? entry.minimum_order_quantity
                        : null;
                    line.minimum_selling_price = entry.minimum_selling_price !== undefined
                        ? entry.minimum_selling_price
                        : null;

                    // Les seuils n'étaient pas connus avant cette réponse : c'est ici qu'un
                    // motif enregistré retrouve le franchissement qu'il couvre.
                    if (line.limit_override_reason) {
                        line.limit_override_for = limitBreach(line);
                    }
                });
            },
            /**
             * Filet pour les envois qui ne passent pas par le bouton, que refreshSubmitButtons
             * grise. En capture sur le document, donc avant le gestionnaire global d'app.js,
             * qui poste par this.submit() : un envoi natif qu'aucun écouteur n'arrête.
             */
            guardSubmit() {
                this.submitForm = this.$el.closest('form');

                if (!this.submitForm) {
                    return;
                }

                document.addEventListener('submit', (event) => {
                    if (event.target === this.submitForm && this.blockedLines.length > 0) {
                        event.preventDefault();
                        event.stopPropagation();
                    }
                });
            },
            /** Un bouton grisé vaut mieux qu'un refus après coup. */
            refreshSubmitButtons() {
                if (!this.submitForm) {
                    return;
                }

                const blocked = this.blockedLines.length > 0;

                this.submitForm.querySelectorAll('button[type="submit"], input[type="submit"]').forEach(button => {
                    button.disabled = blocked;
                    button.title = blocked
                        ? 'Une ligne ne respecte pas les conditions de vente de son article : corrigez-la ou forcez le seuil avec un motif.'
                        : '';
                });
            },
            /** Ce que les conditions du nouveau client changeraient, ligne par ligne. */
            gridDiscountChanges(articles) {
                const changes = [];

                this.pricingLines().forEach(line => {
                    // Un article sans droit chez ce client ne garde rien du précédent : le
                    // palier est repris à la quantité de la ligne, pas à une unité.
                    // Seule la remise est reproposée : le PU de la ligne n'est jamais réécrit.
                    const target = resolveEntry(articles[line.article_id] || null, line.quantity);

                    const unchanged = (parseFloat(line.discount) || 0) === parseFloat(target.discount)
                        && (line.suggested_label || null) === (target.label || null);

                    if (!unchanged) {
                        changes.push({
                            line: line,
                            pricing: (articles[line.article_id] || {}).pricing || null,
                            rate: parseFloat(target.discount),
                            field: target.field || null,
                            label: target.label || null,
                        });
                    }
                });

                return changes;
            },
            /**
             * Le changement de société impose une décision : rien n'est réécrit sans que
             * l'utilisateur l'ait demandé, et rien n'est réécrit à moitié.
             */
            askGridDiscountsUpdate(data) {
                const changes = this.gridDiscountChanges(data.articles || {});

                // Les paliers et les seuils du nouveau client remplacent ceux du précédent
                // sur toutes les lignes : ils décrivent le client, pas la valeur posée sur
                // la ligne. Ils s'adoptent donc même quand rien n'est proposé.
                this.applyArticleData(data.articles || {});

                // Sans profil chez le nouveau client, la grille n'a rien à dire. Une règle
                // négociée, si, et c'est elle qui a rempli changes.
                if (!data.profile && changes.length === 0) {
                    return;
                }

                if (changes.length === 0) {
                    return;
                }

                Swal.fire({
                    title: data.profile ? 'Profil de remise ' + data.profile : 'Conditions du client',
                    html: 'La société du document a été modifiée. Voulez-vous appliquer les '
                        + 'conditions de ce client ?<br><b>' + this.pricingChangesSummary(changes) + '</b>'
                        + '<br><small>Les lignes saisies à la main ne sont pas reprises.</small>',
                    icon: 'question',
                    showCancelButton: true,
                    cancelButtonText: 'Conserver les prix actuels',
                    confirmButtonText: 'Appliquer les conditions',
                    reverseButtons: true,
                    heightAuto: false
                }).then((result) => {
                    if (result.value) {
                        this.applyGridDiscounts(changes);
                        return;
                    }

                    this.keepCurrentPrices(changes);
                });
            },
            /**
             * Prix conservés : ils cessent d'appartenir à la cascade. Sans quoi le premier
             * changement de quantité rappliquerait ce que l'utilisateur vient de refuser.
             */
            keepCurrentPrices(changes) {
                changes.forEach(change => {
                    change.line.pricing = null;
                    change.line.suggested_discount = null;
                    change.line.suggested_field = null;
                    change.line.suggested_label = null;
                });
            },
            pricingChangesSummary(changes) {
                return changes.length > 1 ? changes.length + ' lignes changent de remise' : '1 ligne change de remise';
            },
            applyGridDiscounts(changes) {
                changes.forEach(change => {
                    change.line.pricing = change.pricing;
                    change.line.discount = change.rate;
                    change.line.suggested_discount = change.label ? change.rate : null;
                    change.line.suggested_field = change.field;
                    change.line.suggested_label = change.label;
                });

                this.recomputeToken++;
            },
            // Méthodes de gestion des lignes éco-participation
            addEcoLine(ecoLine) {
                // Trouver l'index de la ligne parent
                const parentIndex = this.lines.findIndex(l => l.uniq === ecoLine.parent_uniq || (ecoLine.parent_id && l.id === ecoLine.parent_id));
                
                if (parentIndex !== -1) {
                    const parentLine = this.lines[parentIndex];
                    ecoLine.eco_parent_line_id = parentLine && parentLine.id ? parentLine.id : (ecoLine.eco_parent_line_id || null);
                    ecoLine.eco_parent_uniq = parentLine ? parentLine.uniq : (ecoLine.eco_parent_uniq || ecoLine.parent_uniq || null);

                    // Calculer les totaux de la ligne éco
                    this.recomputeEcoLine(ecoLine, ecoLine.quantity, ecoLine.quantity);
                    
                    // Insérer la ligne éco juste après la ligne parent
                    this.lines.splice(parentIndex + 1, 0, ecoLine);
                }
            },
            removeEcoLinesForParent(parentUniq) {
                const parentLine = this.lines.find(line => line.uniq === parentUniq);
                const parentId = parentLine ? parentLine.id : null;
                // Supprimer toutes les lignes éco liées à ce parent
                this.lines = this.lines.filter(line => 
                    !(line.is_eco_participation && (
                        line.eco_parent_uniq === parentUniq ||
                        (parentId && line.eco_parent_line_id === parentId) ||
                        line.parent_uniq === parentUniq ||
                        (parentId && line.parent_id === parentId)
                    ))
                );
            },
            removeEcoLinesForArticle(articleUniq) {
                this.removeEcoLinesForParent(articleUniq);
            },
            updateEcoLinesQuantity({parentUniq, newQuantity, oldQuantity}) {
                const parentLine = this.lines.find(line => line.uniq === parentUniq);
                const parentId = parentLine ? parentLine.id : null;
                
                // Trouver toutes les lignes éco liées à ce parent
                this.lines.forEach(line => {
                    if (line.is_eco_participation && (
                        line.eco_parent_uniq === parentUniq ||
                        (parentId && line.eco_parent_line_id === parentId) ||
                        line.parent_uniq === parentUniq ||
                        (parentId && line.parent_id === parentId)
                    )) {
                        this.recomputeEcoLine(line, newQuantity, oldQuantity);
                    }
                });
            },
            getEcoUnitAmount(line, oldQuantity) {
                const explicitUnitAmount = parseFloat(line.eco_unit_amount);
                if (Number.isFinite(explicitUnitAmount)) {
                    return explicitUnitAmount;
                }

                const currentAmount = parseFloat(line.amount);
                if (Number.isFinite(currentAmount)) {
                    return parseFloat(currentAmount.toFixed(4));
                }

                const fallbackRateAmount = parseFloat(line.eco_rate_amount);
                if (Number.isFinite(fallbackRateAmount)) {
                    return fallbackRateAmount;
                }

                return 0;
            },
            recomputeEcoLine(line, parentQuantity, oldQuantity) {
                const nextQuantity = parseFloat(parentQuantity) || 0;
                const unitAmount = this.getEcoUnitAmount(line, oldQuantity);

                line.eco_unit_amount = unitAmount;
                line.amount = unitAmount;
                line.quantity = nextQuantity;
                line.total_ht = parseFloat((line.quantity * line.amount).toFixed(4));
                line.total_discount = 0;
                line.total_after_discount = line.total_ht;
                line.total_vat = parseFloat((line.total_after_discount * ((parseFloat(line.vat) || 0) / 100)).toFixed(2));
                line.total_ttc = parseFloat((line.total_after_discount + line.total_vat).toFixed(2));

                if (this.model == 'creditnote') {
                    line.total_ht = line.total_ht * -1;
                    line.total_after_discount = line.total_after_discount * -1;
                    line.total_vat = line.total_vat * -1;
                    line.total_ttc = line.total_ttc * -1;
                }
            }
        },
        mounted(){
            $('#address_id, #delivery_address_id').on('change', () => this.loadShipping());
            this.guardSubmit();
            this.refreshSubmitButtons();
            this.editable = this.isEditable;
            this.isAutoliquidation = this.oldAutoliquidation
            this.showKitDetails = this.oldShowKitDetails == 1
            this.showAvailability = this.oldShowAvailability == 1
            this.discount = this.oldDiscount
            this.shippingAutoAllowed = !this.id

            const jsonLineBackup = JSON.parse(this.oldLines)
            if (Array.isArray(jsonLineBackup)) {
                if (jsonLineBackup.length == 0) {
                    this.addRow(null)
                } else {
                    jsonLineBackup.forEach(line => {
                        this.addRow(line)
                    })
                    this.regroupLines()
                    // Saisie refusée : aucun chargement ne viendra déclencher l'observateur.
                    this.loadKits()
                }
                this.loading = false
            } else {
                this.getLines(jsonLineBackup)
            }

            if($('#company_id').length > 0){
                const self = this;
                this.companyId = $('#company_id').val() || null;

                // Les lignes reprises d'une saisie refusée sont déjà là : elles n'ont pas
                // attendu de chargement, donc aucun observateur ne les a vues arriver.
                this.loadArticleData();

                $('#company_id').on('change', function () {
                    self.companyId = $(this).val() || null;
                    self.refreshGridDiscounts();
                    self.loadConditions();
                    // Les adresses de la société arrivent après : on leur laisse le temps d'être posées.
                    setTimeout(() => self.loadShipping(), 1200);

                    setTimeout(() => {
                        if($('#default_vat').length > 0 && $('#default_vat').val() != ""){
                            self.globalTva = $('#default_vat').val();
                        } else {
                            self.globalTva = self.tvaGlobal;
                        }
                    }, 1000)
                })
            }
        }
    }
</script>


